import { InformationCircleIcon } from '@heroicons/react/24/solid'
import { Tooltip } from 'react-tooltip'
import styles from './InfoTooltip.module.scss'

/**
 * 공통 정보 툴팁 아이콘 컴포넌트
 *
 * @param {string} id - tooltip id (유니크해야 함)
 * @param {string} content - tooltip에 표시할 문자열 (여러 줄 가능)
 * @param {'top'|'right'|'bottom'|'left'} [placement='top'] - tooltip 표시 위치
 * @param {string} [className] - 아이콘에 추가할 클래스명
 * @param {Object} [tooltipProps] - react-tooltip에 그대로 전달할 추가 props
 */
export const InfoTooltip = ({ id, content, placement = 'top', className, tooltipProps = {} }) => {
	if (!id) {
		console.warn('InfoTooltip: tooltip id is required for accessibility.')
	}

	return (
		<>
			<InformationCircleIcon
				className={`${styles.noticeIcon}${className ? ` ${className}` : ''}`}
				data-tooltip-id={id}
				data-tooltip-content={content}
			/>
			<Tooltip
				id={id}
				place={placement}
				className={styles.tooltip}
				style={{ whiteSpace: 'pre-line' }}
				positionStrategy="fixed"
				{...tooltipProps}
			/>
		</>
	)
}
